module.exports = __webpack_public_path__ + "static/media/temperature.85790f64.png";